// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ShareMedium } from "../schema";

export function serialize_ShareMedium_internal(value: ShareMedium): unknown {
  return ((value: "COPY_LINK" | "FACEBOOK" | "FACEBOOK_WORKSPACE" | "TWITTER" | "LINKEDIN" | "EMAIL" | "IFRAME" | "SCORM" | "TEAMS" | "WECHAT" | "XING" | "QRCODE"): unknown => {
    return value;
  })(value);
}
export function serialize_ShareMedium(obj: ShareMedium): string {
  return renderJsonWithNumbersAsBigint(serialize_ShareMedium_internal(obj));
}
export function deserialize_ShareMedium_internal(value: unknown): ParserResult<ShareMedium> {
  return ((value: unknown): ParserResult<"COPY_LINK" | "FACEBOOK" | "FACEBOOK_WORKSPACE" | "TWITTER" | "LINKEDIN" | "EMAIL" | "IFRAME" | "SCORM" | "TEAMS" | "WECHAT" | "XING" | "QRCODE"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/ShareMedium]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "COPY_LINK":
        return { success: true, value: "COPY_LINK" };
      case "FACEBOOK":
        return { success: true, value: "FACEBOOK" };
      case "FACEBOOK_WORKSPACE":
        return { success: true, value: "FACEBOOK_WORKSPACE" };
      case "TWITTER":
        return { success: true, value: "TWITTER" };
      case "LINKEDIN":
        return { success: true, value: "LINKEDIN" };
      case "EMAIL":
        return { success: true, value: "EMAIL" };
      case "IFRAME":
        return { success: true, value: "IFRAME" };
      case "SCORM":
        return { success: true, value: "SCORM" };
      case "TEAMS":
        return { success: true, value: "TEAMS" };
      case "WECHAT":
        return { success: true, value: "WECHAT" };
      case "XING":
        return { success: true, value: "XING" };
      case "QRCODE":
        return { success: true, value: "QRCODE" };
      default:
        return { success: false, reason: `[#/components/schemas/ShareMedium]: '${value}' expected to be enum, one of 'COPY_LINK, FACEBOOK, FACEBOOK_WORKSPACE, TWITTER, LINKEDIN, EMAIL, IFRAME, SCORM, TEAMS, WECHAT, XING, QRCODE'.` };
    }
  })(value);
}
export function deserialize_ShareMedium(str: string): ParserResult<ShareMedium> {
  return deserialize_ShareMedium_internal(parseJsonWithNumbersAsBigint(str));
}
